import BigNumber from 'bignumber.js';

import { Order } from '#/api/orders';

export function isNewOrder(order: Pick<Order, 'status'>): boolean {
  return order.status === 'NEW';
}

export function isCancelledOrder(
  order: Pick<Order, 'status' | 'remaining_size'>,
): boolean {
  return order.status === 'CLOSED' && order.remaining_size.isGreaterThan(0);
}

export function hadSomeFill(
  order: Pick<Order, 'size' | 'remaining_size'>,
): boolean {
  return order.remaining_size.isLessThan(order.size);
}

export function isMarketOrder(order: Pick<Order, 'type'>): boolean {
  return order.type === 'MARKET';
}

export function isLimitOrder(order: Pick<Order, 'type'>): boolean {
  return order.type === 'LIMIT';
}

export function filledSize(
  order: Pick<Order, 'size' | 'remaining_size'>,
): BigNumber {
  return order.size.minus(order.remaining_size);
}
